export const RECEIVE_TRADE_SUPPORTING_DOCUMENTS = "RECEIVE_TRADE_SUPPORTING_DOCUMENTS";
export const CREATE_TRADE_SUPPORTING_DOCUMENTS = "CREATE_TRADE_SUPPORTING_DOCUMENTS";
export const REMOVE_TRADE_SUPPORTING_DOCUMENTS = "REMOVE_TRADE_SUPPORTING_DOCUMENTS";
export const REMOVE_TRADE_SUPPORTING_DOCUMENT = "REMOVE_TRADE_SUPPORTING_DOCUMENT";



// WEBPACK FOOTER //
// ./src/features/supporting_documents/actionTypes.js